/// <amd-module name="Build/Admin/Tabs/AgentCloudsTab" />
import * as React from "react";

import { Components, VssComponent, IVssComponentProperties, IVssComponentContext, WrappedComponent } from "VSS/Platform/Layout";

import { NavigationActionCreator } from "Build/Admin/Common/Actions/NavigationActionCreator";

export interface IAgentCloudsTabState {
    agentCloudId: number | undefined;
}

class AgentCloudsTab extends VssComponent<IVssComponentProperties, IAgentCloudsTabState> {
    private _navigationActionCreator: NavigationActionCreator;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this._navigationActionCreator = new NavigationActionCreator({ pageContext: context.pageContext });
        this.state = this._getState();
    }

    public render(): JSX.Element {
        return <WrappedComponent
            dependencies={["ms.vss-build-web.admin.agentcloudslist"]}
            wrappedType={"ms.vss-build-web.admin-agent-clouds-list-view-component"}
        />;
    }

    private _getState(): IAgentCloudsTabState {
        return {
            agentCloudId: this._navigationActionCreator.getAgentCloudIdParam()
        };
    }
}

Components.add("build-admin-agent-clouds-tab", AgentCloudsTab);
